export default "https://assets.egbcdn.net/assets/packs/_/images/referrals/icon-e-33ab948f9777f15db73a417fc83ae11f.png";